import { range } from "lodash";
import React, { useState } from "react";
import DatePicker from "react-datepicker";

const DateTimePicker = (props) => {
  let { placeholder, minDate, maxDate } = props;
  const [startDate, setStartDate] = useState(new Date());
  const years = range(1900, new Date().getFullYear() + 3, 1);
  const months = [
    "Tháng 1",
    "Tháng 2",
    "Tháng 3",
    "Tháng 4",
    "Tháng 5",
    "Tháng 6",
    "Tháng 7",
    "Tháng 8",
    "Tháng 9",
    "Tháng 10",
    "Tháng 11",
    "Tháng 12",
  ];
  return (
    <DatePicker
      format={"dd/MM/yyyy"}
      dateFormat={"dd/MM/yyyy"}
      clearIcon={null}
      placeholderText={placeholder}
      className="form-control input-sm datepicker-default hasDatepicker"
      wrapperClassName="form-control"
      renderCustomHeader={({
        date,
        changeYear,
        changeMonth,
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled,
      }) => (
        <div
          style={{
            margin: "0 0 0 0",
            display: "flex",
            justifyContent: "space-around",
          }}
        >
          <a
            onClick={decreaseMonth}
            disabled={prevMonthButtonDisabled}
            className="icon-date-picker"
            href={() => false}
          >
            <i class="fas fa-caret-left"></i>
          </a>
          <select
            value={date.getFullYear()}
            onChange={({ target: { value } }) => changeYear(value)}
          >
            {years.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>

          <select
            value={months[date.getMonth()]}
            onChange={({ target: { value } }) =>
              changeMonth(months.indexOf(value))
            }
          >
            {months.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>

          <a
            onClick={increaseMonth}
            disabled={nextMonthButtonDisabled}
            className="icon-date-picker"
            href={() => false}
          >
            <i class="fas fa-caret-right"></i>
          </a>
        </div>
      )}
      selected={props.value}
      onChange={props.onChange}
      customInput={props.customInput}
      name={props.name}
      customInputRef={props.customInputRef}
      readOnly={props.readOnly}
      onKeyDown={props.onKeyDown}
      minDate={minDate}
      maxDate={maxDate}
    />
  );
};
export default DateTimePicker;
